import request from "@/util/request";

export function downBlobFilePost(url, data, fileName) {
  return request({
    url: url,
    method: "post",
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    data: data,
  }).then((response) => {
    // 处理返回的文件流
    const blob = response.data;
    if (blob && blob.size === 0) {
      return;
    }
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    window.setTimeout(function () {
      window.URL.revokeObjectURL(blob);
      document.body.removeChild(link);
    }, 0);
  });
}

export function getAppUrl() {
  return request({
    url: "/admin/device/update/deviceLatestVersion",
    method: "post",
    data: { typeId: 2 },
  });
}
export function getDeviceAppUrl() {
  return request({
    url: "/admin/device/update/deviceLatestVersion",
    method: "post",
    data: { typeId: 1 },
  });
}
export function getPadAppUrl() {
  return request({
    url: "/admin/device/update/latestFullUpdate",
    method: "get",
    params: { typeId: 5 },
  });
}
